module.exports = __webpack_public_path__ + "static/media/Calendar.8d2aaa7f.svg";